import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import ProposalCopyingForRecalContMain from "presentation/view/container/ProposalCopyingForRecal/ProposalCopyingForRecalContMain";

CommonEntrypoint(<ProposalCopyingForRecalContMain />)